import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              全题材分类浏览
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              覆盖恋爱、热血、奇幻等九大题材，总能找到你爱看的
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`} />
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">{cat.count.toLocaleString()}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}